(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hongye-heritage-story"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('hy-heritage-story')){
 customElements.define('hy-heritage-story',class extends HTMLElement{
  connectedCallback(){
   if(this.ready)return;
   this.ready=true;
   this.addEventListener('click',event=>{
    const opener=event.target.closest('[data-hy-work-open]');
    if(opener){
     const dialog=this.querySelector('#'+opener.dataset.hyWorkOpen);
     if(dialog){const source=dialog.querySelector('template[data-work-image]');if(source){source.replaceWith(source.content.cloneNode(true));}dialog.showModal();}
    }
    const closer=event.target.closest('[data-hy-work-close]');
    if(closer)closer.closest('dialog').close();
    if(event.target instanceof HTMLDialogElement){const r=event.target.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)event.target.close();}
   });
  }
 });
}


  } catch(e) { console.error(e); }
})();
})();
